import styled from 'styled-components'
import { SIZES } from '../../../constants'

export default styled.div`
  height: 92px;
  position: relative;
  margin-bottom: 15px;
  overflow: hidden;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    height: 114px;
  }
`
